import { ContextHeader } from './ContextHeader/ContextHeader';
import { GlobalHeader } from './GlobalHeader/GlobalHeader';
import { MobileChin } from './MobileChin/MobileChin';
import { Sidebar } from './Sidebar/Sidebar';
import { PageContent } from './PageContent/PageContent';

export default {
  ContextHeader,
  GlobalHeader,
  MobileChin,
  Sidebar,
  PageContent,
};
